import React, { createContext, useState, useContext } from 'react';

// Create a Context for authentication
const techPredAuthContext = createContext();

// Custom hook to use authentication context
export const useTechPredAuth = () => {
  return useContext(techPredAuthContext);
};

// AuthProvider to wrap the application and provide authentication state
export const TechPredAuthProvider = ({ children }) => {
  const isauth = !localStorage.getItem('techpredtoken');
  const [isTechPredAuthenticated, setIsTechPredAuthenticated] = useState(!isauth);
  const techPredlogin = () => {
    setIsTechPredAuthenticated(true);
  };

  const techpredlogout = () => {
    setIsTechPredAuthenticated(false);
  };

  return (
    <techPredAuthContext.Provider value={{ isTechPredAuthenticated, techPredlogin, techpredlogout }}>
      {children}
    </techPredAuthContext.Provider>
  );
};
